/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Actions_Compare1Inputs */

const id_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan`)
};

const ms_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandingkan`)
};

const da_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign`)
};

const de_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichen`)
};

const en_us2_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare`)
};

const es_es2_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar`)
};

const es_mx2_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar`)
};

const fil_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihambing`)
};

const fr_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparer`)
};

const it_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta`)
};

const hu_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összehasonlítás`)
};

const nl_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergelijken`)
};

const no_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammenlign`)
};

const pl_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porównaj`)
};

const pt_br2_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar`)
};

const pt_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar`)
};

const ro_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compară`)
};

const fi_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertaile`)
};

const sv_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jämför`)
};

const vi_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sánh`)
};

const tr_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karşılaştır`)
};

const cs_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porovnat`)
};

const bg_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравни`)
};

const ru_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнить`)
};

const uk_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порівняти`)
};

const ar_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقارنة`)
};

const hi_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तुलना करें`)
};

const th_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปรียบเทียบ`)
};

const ja_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較`)
};

const zh_cn2_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比`)
};

const zh_hant1_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對比`)
};

const ko_offerdetail_actions_compare1 = /** @type {(inputs: Offerdetail_Actions_Compare1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비교`)
};

/**
* | output |
* | --- |
* | "Compare" |
*
* @param {Offerdetail_Actions_Compare1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_actions_compare1 = /** @type {((inputs?: Offerdetail_Actions_Compare1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Actions_Compare1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_actions_compare1(inputs)
	if (locale === "ms") return ms_offerdetail_actions_compare1(inputs)
	if (locale === "da") return da_offerdetail_actions_compare1(inputs)
	if (locale === "de") return de_offerdetail_actions_compare1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_actions_compare1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_actions_compare1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_actions_compare1(inputs)
	if (locale === "fil") return fil_offerdetail_actions_compare1(inputs)
	if (locale === "fr") return fr_offerdetail_actions_compare1(inputs)
	if (locale === "it") return it_offerdetail_actions_compare1(inputs)
	if (locale === "hu") return hu_offerdetail_actions_compare1(inputs)
	if (locale === "nl") return nl_offerdetail_actions_compare1(inputs)
	if (locale === "no") return no_offerdetail_actions_compare1(inputs)
	if (locale === "pl") return pl_offerdetail_actions_compare1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_actions_compare1(inputs)
	if (locale === "pt") return pt_offerdetail_actions_compare1(inputs)
	if (locale === "ro") return ro_offerdetail_actions_compare1(inputs)
	if (locale === "fi") return fi_offerdetail_actions_compare1(inputs)
	if (locale === "sv") return sv_offerdetail_actions_compare1(inputs)
	if (locale === "vi") return vi_offerdetail_actions_compare1(inputs)
	if (locale === "tr") return tr_offerdetail_actions_compare1(inputs)
	if (locale === "cs") return cs_offerdetail_actions_compare1(inputs)
	if (locale === "bg") return bg_offerdetail_actions_compare1(inputs)
	if (locale === "ru") return ru_offerdetail_actions_compare1(inputs)
	if (locale === "uk") return uk_offerdetail_actions_compare1(inputs)
	if (locale === "ar") return ar_offerdetail_actions_compare1(inputs)
	if (locale === "hi") return hi_offerdetail_actions_compare1(inputs)
	if (locale === "th") return th_offerdetail_actions_compare1(inputs)
	if (locale === "ja") return ja_offerdetail_actions_compare1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_actions_compare1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_actions_compare1(inputs)
	return ko_offerdetail_actions_compare1(inputs)
});
export { offerdetail_actions_compare1 as "offerDetail.actions.compare" }